export default "__VITE_ASSET__CzD15vJk__"